import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AddressProvider } from './components/context/AddressContext';
import { OrdersProvider } from './components/context/OrdersContext';
import { SettingsProvider } from './components/context/SettingsContext';
import { ReportTypeProvider } from './components/context/ReportTypeContext';
import { PromoCodeProvider } from './components/context/PromoCodeContext';
import { CartProvider } from './components/context/CartContext';
import { WishlistProvider } from './components/context/WishlistContext';
import { ShippingMethodProvider } from './components/context/ShippingMethodContext';
import {BlogProvider} from './components/context/BlogContext';
import { ContactProvider } from './components/context/ContactContext';
import {PromoCodeCheckContext} from './components/context/PromoCodeCheckContext';
import {PromoProvider} from './components/context/PromoContext';
import {ToastProvider } from './components/context/ToastContext';
import { PaymentGatewayProvider } from './components/context/PaymentGatewayContext';
import {CustomerReviewProvider} from './components/context/CustomerReviewContext';
import {ReturnProvider } from './components/context/ReturnContext';
import {OrderCancelProvider} from './components/context/OrderCancelContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AddressProvider>
      <OrdersProvider>
        <SettingsProvider>
          <ReportTypeProvider>
            <PromoCodeProvider>
              <CartProvider>
                <WishlistProvider>
                  <ShippingMethodProvider>
                    <BlogProvider>
                      <ContactProvider>
                        <PromoCodeCheckContext> 
                          <PromoProvider>
                            <ToastProvider >
                             <PaymentGatewayProvider>
                              <CustomerReviewProvider>
                                <ReturnProvider >
                                  <OrderCancelProvider>
                                        <App />
                                  </OrderCancelProvider>
                                </ReturnProvider>
                                </CustomerReviewProvider>
                              </PaymentGatewayProvider>
                            </ToastProvider>
                          </PromoProvider>
                        </PromoCodeCheckContext>
                      </ContactProvider>
                    </BlogProvider>
                  </ShippingMethodProvider>
                </WishlistProvider>
              </CartProvider>
            </PromoCodeProvider>
          </ReportTypeProvider>
        </SettingsProvider>
      </OrdersProvider>
    </AddressProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
